import * as actions from './project.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ProjectModel } from '@smarttask-common/src/lib/models/Project/Core/ProjectModel';

export const projectAdapter = createEntityAdapter<ProjectModel>({
    selectId: (x) => x.project_id,
});
export interface ProjectState extends EntityState<ProjectModel> {
    selected_project_id: string;
}

export const initialState: ProjectState = projectAdapter.getInitialState({
    selected_project_id: undefined,
});

export function ProjectReducers(state: ProjectState = initialState, action: actions.ProjectActions) {
    switch (action.type) {
        case actions.ProjectActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_project_id: action.selected_project_id };
            //console.log(state);
            return state;

        case actions.ProjectActionTypes.ADD_PROJECT:
            return projectAdapter.addOne(action.project, state);

        case actions.ProjectActionTypes.ADD_PROJECTS:
            return projectAdapter.addMany(action.projects, state);

        case actions.ProjectActionTypes.UPSERT_PROJECT:
            return projectAdapter.upsertOne(action.project, state);

        case actions.ProjectActionTypes.UPSERT_PROJECTS:
            return projectAdapter.upsertMany(action.projects, state);

        case actions.ProjectActionTypes.UPDATE_PROJECT:
            return projectAdapter.updateOne(action.project, state);

        case actions.ProjectActionTypes.UPDATE_PROJECTS:
            return projectAdapter.updateMany(action.projects, state);

        case actions.ProjectActionTypes.DELETE_PROJECT:
            // if(state.selectedProjectId == action.id){
            //   state.selectedProjectId = undefined;
            // }
            return projectAdapter.removeOne(action.id, state);

        case actions.ProjectActionTypes.DELETE_PROJECTS:
            // if(action.ids.indexOf(state.selectedProjectId) > -1){
            //   state.selectedProjectId = undefined;
            // }
            return projectAdapter.removeMany(action.ids, state);

        case actions.ProjectActionTypes.DELETE_ALL_PROJECTS:
            return projectAdapter.removeMany(action.ids, state);

        case actions.ProjectActionTypes.DELETE_ALL:
            return projectAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getProjectState = createFeatureSelector<ProjectState>('project');

export const { selectIds, selectEntities, selectAll, selectTotal } = projectAdapter.getSelectors(getProjectState);

const getSelectedProjectIdState = (state: ProjectState) => {
    return state.selected_project_id;
};
export const getSelectedProjectId = createSelector(getProjectState, getSelectedProjectIdState);

export const getSelectedProject = createSelector(getProjectState, (state: ProjectState) => {
    if (state.selected_project_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_project_id];
});
